let alert;
let language = localStorage.getItem("PCMSClientLanguage");
if (language == 2) {
  // English - En
  alert = {
    success: {
      save: "Saved successfully",
      send: "Your information has been sent successfully",
      submit: "The information has been successfully submitted",
      done: "mission accomplished",
      edit: "The information has been edited successfully",
      delete: "Successfully deleted",
      login: "Dear companion, welcome back...",
      codeSent: "The validation code has been sent to you",
      register: "Welcome, Your registration was successful",
      changeStatus: "User Status Edited Successfully",
      setDefaultImage: "Default image saved successfully",
      changeAvatar: "Profile picture edited successfully",
      changePassword: "Your password has been edited successfully",
      addToCart: "The desired product has been added to your shopping cart",
      updateCart: "Your shopping cart has been successfully updated",
      deleteCart:
        "Your shopping cart has been successfully deleted and emptied",
      commentSent: "Your comment has been sent successfully",
      demoRequestSent:
        "Your request has been registered, you will be contacted as soon as possible",
      messageSent: "Your message has been successfully sent",
      contactSent:
        "Your message has been successfully registered. Our colleagues will contact you as soon as possible.",
      cooperationSent:
        "Your information has been successfully registered. Our colleagues will contact you as soon as possible.",
      loading: "Loading Information",
    },
    error: {
      access: "Unfortunately, you do not have access to this information",
      notFound: "Required information does not exist",
      pageNotFound: "There is no item to display",
      server: "There is a problem to connect server",
      post: "There was a problem with the operation, please try again",
      upload: "The size or extension of the file is not correct",
      empty: "please fill the mandatory fields",
      emptyTitle: "please fill the Title",
      emptyComment: "Please write your comment",
      captcha: "Captcha code is not valid",
    },
  };
} else if (language == 3) {
  // Arabic - Ar
  alert = {
    success: {
      save: "حفظ بنجاح",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "مسجل بنجاح",
      done: "با موفقیت انجام شد",
      edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      changeStatusJob: "وضعیت مدنظر با موفقیت ویرایش شد",
      login: "به سیستم مدیریت پروژه مایار خوش آمدید",
      codeSent: "کد 5 رقمی اعتبارسنجی برای شما ارسال شد",
      register: "خوش آمدید، ثبت نام شما با موفقیت انجام شد",
      changeStatus: "وضعیت کاربر با موفقیت ویرایش شد",
      setDefaultImage: "تصویر پیش فرض با موفقیت ثبت شد",
      changeAvatar: "تصویر پروفایل با موفقیت ویرایش شد",
      changePassword: "رمز عبور شما با موفقیت ویرایش شد",
      addToCart: "محصول مدنظر به سبد خرید شما اضافه شد",
      updateCart: "سبد خرید شما با موفقیت به روزرسانی شد",
      deleteCart: "سبد خرید شما با موفقیت حذف و خالی شد",
      addWorkspace: "میزکار جدید شما با موفقیت ثبت شد",
      editWorkspace: "میزکار مدنظر با موفقیت ویرایش شد",
      deleteWorkspace: "میزکار مدنظر با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
      demoRequestSent:
        "درخواست شما ثبت شد، در اسرع وقت با شما تماس گرفته میشود",
      messageSent: "پیام شما با موفقیت ارسال شد",
      contactSent:
        "پیام شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      cooperationSent:
        "اطلاعات شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      loading: "در حال دریافت اطلاعات",
      payment: "پرداخت شما با موفقیت انجام شد",
      chargeWallet: "کیف پول شما با موفقیت شارژ شد",
    },
    error: {
      access: "متاسفانه شما به این قسمت دسترسی ندارید",
      notFound: "اطلاعات مدنظر وجود ندارد",
      pageNotFound: "موردی جهت نمایش وجود ندارد",
      server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
      post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
      upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
      empty: "لطفا فیلدهای الزامی را وارد کنید",
      emptyTitle: "لطفا عنوان را وارد کنید",
      emptyComment: "لطفا نظر خود را بنویسید",
      captcha: "کد کپچا معتبر نمی‌باشد",
      emptyFields: "لطفا موارد الزامی را وارد کنید",
    },
  };
} else if (language == 4) {
  // France - Fr
  alert = {
    success: {
      save: "با موفقیت ذخیره شد",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "اطلاعات شما با موفقیت ثبت شد",
      done: "با موفقیت انجام شد",
      edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      login: "به سیستم مدیریت پروژه مایار خوش آمدید",
      codeSent: "کد 5 رقمی اعتبارسنجی برای شما ارسال شد",
      register: "خوش آمدید، ثبت نام شما با موفقیت انجام شد",
      changeStatus: "وضعیت کاربر با موفقیت ویرایش شد",
      setDefaultImage: "تصویر پیش فرض با موفقیت ثبت شد",
      changeAvatar: "تصویر پروفایل با موفقیت ویرایش شد",
      changePassword: "رمز عبور شما با موفقیت ویرایش شد",
      addToCart: "محصول مدنظر به سبد خرید شما اضافه شد",
      updateCart: "سبد خرید شما با موفقیت به روزرسانی شد",
      deleteCart: "سبد خرید شما با موفقیت حذف و خالی شد",
      addWorkspace: "میزکار جدید شما با موفقیت ثبت شد",
      editWorkspace: "میزکار مدنظر با موفقیت ویرایش شد",
      deleteWorkspace: "میزکار مدنظر با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
      demoRequestSent:
        "درخواست شما ثبت شد، در اسرع وقت با شما تماس گرفته میشود",
      messageSent: "پیام شما با موفقیت ارسال شد",
      contactSent:
        "پیام شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      cooperationSent:
        "اطلاعات شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      loading: "در حال دریافت اطلاعات",
    },
    error: {
      access: "متاسفانه شما به این قسمت دسترسی ندارید",
      notFound: "اطلاعات مدنظر وجود ندارد",
      pageNotFound: "موردی جهت نمایش وجود ندارد",
      server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
      post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
      upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
      empty: "لطفا فیلدهای الزامی را وارد کنید",
      emptyTitle: "لطفا عنوان را وارد کنید",
      emptyComment: "لطفا نظر خود را بنویسید",
      captcha: "کد کپچا معتبر نمی‌باشد",
    },
  };
} else if (language == 5) {
  // Turkey - Tr
  alert = {
    success: {
      save: "با موفقیت ذخیره شد",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "اطلاعات شما با موفقیت ثبت شد",
      done: "با موفقیت انجام شد",
      edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      login: "به سیستم مدیریت پروژه مایار خوش آمدید",
      codeSent: "کد 5 رقمی اعتبارسنجی برای شما ارسال شد",
      register: "خوش آمدید، ثبت نام شما با موفقیت انجام شد",
      changeStatus: "وضعیت کاربر با موفقیت ویرایش شد",
      setDefaultImage: "تصویر پیش فرض با موفقیت ثبت شد",
      changeAvatar: "تصویر پروفایل با موفقیت ویرایش شد",
      changePassword: "رمز عبور شما با موفقیت ویرایش شد",
      addToCart: "محصول مدنظر به سبد خرید شما اضافه شد",
      updateCart: "سبد خرید شما با موفقیت به روزرسانی شد",
      deleteCart: "سبد خرید شما با موفقیت حذف و خالی شد",
      addWorkspace: "میزکار جدید شما با موفقیت ثبت شد",
      editWorkspace: "میزکار مدنظر با موفقیت ویرایش شد",
      deleteWorkspace: "میزکار مدنظر با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
      demoRequestSent:
        "درخواست شما ثبت شد، در اسرع وقت با شما تماس گرفته میشود",
      messageSent: "پیام شما با موفقیت ارسال شد",
      contactSent:
        "پیام شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      cooperationSent:
        "اطلاعات شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      loading: "در حال دریافت اطلاعات",
    },
    error: {
      access: "متاسفانه شما به این قسمت دسترسی ندارید",
      notFound: "اطلاعات مدنظر وجود ندارد",
      pageNotFound: "موردی جهت نمایش وجود ندارد",
      server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
      post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
      upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
      empty: "لطفا فیلدهای الزامی را وارد کنید",
      emptyTitle: "لطفا عنوان را وارد کنید",
      emptyComment: "لطفا نظر خود را بنویسید",
      captcha: "کد کپچا معتبر نمی‌باشد",
    },
  };
} else {
  // Farsi - Fa  (Default Language)
  alert = {
    success: {
      changeStatusJob: "وضعیت مدنظر با موفقیت ویرایش شد",
      save: "با موفقیت ذخیره شد",
      send: "اطلاعات شما با موفقیت ارسال شد",
      submit: "اطلاعات شما با موفقیت ثبت شد",
      done: "با موفقیت انجام شد",
      edit: "اطلاعات مدنظر با موفقیت ویرایش شد",
      delete: "با موفقیت حذف شد",
      login: "به پنل کاربری وبسایت خوش آمدید",
      codeSent: "کد اعتبارسنجی به شماره شما ارسال شد",
      register: "خوش آمدید، ثبت نام شما با موفقیت انجام شد",
      completeRegister: "با سپاس، اطلاعات پروفایل شما تکمیل و حساب شما فعال شد",
      changeStatus: "وضعیت کاربر با موفقیت ویرایش شد",
      setDefaultImage: "تصویر پیش فرض با موفقیت ثبت شد",
      changeAvatar: "تصویر پروفایل با موفقیت ویرایش شد",
      changePassword: "رمز عبور شما با موفقیت ویرایش شد",
      addToCart: "محصول مدنظر به سبد خرید شما اضافه شد",
      updateCart: "سبد خرید شما با موفقیت به روزرسانی شد",
      deleteCart: "سبد خرید شما با موفقیت حذف و خالی شد",
      addWorkspace: "میزکار جدید شما با موفقیت ثبت شد",
      editWorkspace: "میزکار مدنظر با موفقیت ویرایش شد",
      deleteWorkspace: "میزکار مدنظر با موفقیت حذف شد",
      commentSent: "نظر شما ارسال شد و پس از تایید در سایت درج خواهد شد",
      demoRequestSent:
        "درخواست شما ثبت شد، در اسرع وقت با شما تماس گرفته میشود",
      messageSent: "پیام شما با موفقیت ارسال شد",
      contactSent:
        "پیام شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      cooperationSent:
        "اطلاعات شما با موفقیت ثبت شد. همکاران ما در اسرع وقت با شما تماس خواهند گرفت.",
      loading: "در حال دریافت اطلاعات",
      payment: "پرداخت شما با موفقیت انجام شد",
      chargeWallet: "کیف پول شما با موفقیت شارژ شد",
    },
    error: {
      access: "متاسفانه شما به این قسمت دسترسی ندارید",
      notFound: "اطلاعات مدنظر وجود ندارد",
      pageNotFound: "موردی جهت نمایش وجود ندارد",
      server: "مشکلی در برقراری ارتباط با سرور وجود دارد",
      post: "مشکلی در انجام عملیات وجود دارد. مجدد تلاش کنید",
      upload: "حجم و یا پسوند فایل مدنظر غیرمجاز می‌باشد",
      empty: "لطفا فیلدهای الزامی را وارد کنید",
      emptyTitle: "لطفا عنوان را وارد کنید",
      emptyComment: "لطفا نظر خود را بنویسید",
      emptyPrice: "لطفا مبلغ را به صورت صحیح وارد کنید",
      minCharge: "مبلغ وارد شده کمتر از حداقل مجاز جهت افزایش اعتبار می‌باشد",
      wrongMobile: "لطفا شماره همراه به صورت صحیح وارد کنید",
      mobileNotFound: "شماره همراه وارد شده یافت نشد",
      wrongCode: "لطفا کد اعتبارسنجی را به صورت صحیح وارد نمایید",
      captcha: "کد کپچا معتبر نمی‌باشد",
      passwordNotMatch: "تکرار رمز عبور با رمز عبور همخوانی ندارد",
      emptySelect: "هیچ موردی انتخاب نشده است",
      emptyFields: "لطفا موارد الزامی را وارد کنید",
    },
  };
}

export default alert;
